import script from "./BaseAnchor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAnchor.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAnchor.vue?vue&type=style&index=0&id=0e404338&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e404338"]])

export default __exports__